import { marketCodes, markets } from "@ilc-technology/env-utils";

const EFCOM_MARKET_CODE_LENGTH = 2;

export const getEfComMarketCodeBySalesOffice = (
  salesOfficeCode?: string,
  fallbackMarket?: string
): string | undefined => {
  if (!salesOfficeCode && !fallbackMarket) {
    return undefined;
  }

  const salesOfficeMarket =
    salesOfficeCode && salesOfficeCode.length >= EFCOM_MARKET_CODE_LENGTH
      ? salesOfficeCode.substring(0, EFCOM_MARKET_CODE_LENGTH)
      : undefined;

  const salesOfficeEfcomMarket = markets.find(({ junoMarketCode }) => junoMarketCode === salesOfficeMarket)?.marketCode;

  if (salesOfficeEfcomMarket && marketCodes.includes(salesOfficeEfcomMarket)) {
    return salesOfficeEfcomMarket;
  }

  const fallbackEfComMarket = markets.find(({ junoMarketCode }) => junoMarketCode === fallbackMarket)?.marketCode;

  if (fallbackEfComMarket && marketCodes.includes(fallbackEfComMarket)) {
    return fallbackEfComMarket;
  }

  return undefined;
};
